import { AjvError } from "@rjsf/core";
import { TFunction } from "i18next";
const CustomErrorTransformer = (errors: AjvError[], translator: TFunction): AjvError[] => {
    return errors.map((error: AjvError) => {
        error.message = translator(error.name);
        return error;
    });
};
export default CustomErrorTransformer;
